export const countryCodes = [
  {
    name: "Afghanistan",
    callingCode: "+93",
    currency: "AFN",
    currencyName: "Afghani",
  },
  {
    name: "Albania",
    callingCode: "+355",
    currency: "ALL",
    currencyName: "Lek",
  },
  {
    name: "Algeria",
    callingCode: "+213",
    currency: "DZD",
    currencyName: "Algerian Dinar",
  },
  {
    name: "Argentina",
    callingCode: "+54",
    currency: "ARS",
    currencyName: "Argentine Peso",
  },
  {
    name: "Australia",
    callingCode: "+61",
    currency: "AUD",
    currencyName: "Australian Dollar",
  },
  {
    name: "Austria",
    callingCode: "+43",
    currency: "EUR",
    currencyName: "Euro",
  },
  {
    name: "Belgium",
    callingCode: "+32",
    currency: "EUR",
    currencyName: "Euro",
  },
  {
    name: "Botswana",
    callingCode: "+267",
    currency: "BWP",
    currencyName: "Pula",
  },
  {
    name: "Brazil",
    callingCode: "+55",
    currency: "BRL",
    currencyName: "Brazilian Real",
  },
  {
    name: "Canada",
    callingCode: "+1",
    currency: "CAD",
    currencyName: "Canadian Dollar",
  },
  {
    name: "China",
    callingCode: "+86",
    currency: "CNY",
    currencyName: "Yuan",
  },
  {
    name: "Egypt",
    callingCode: "+20",
    currency: "EGP",
    currencyName: "Egyptian Pound",
  },
  {
    name: "France",
    callingCode: "+33",
    currency: "EUR",
    currencyName: "Euro",
  },
  {
    name: "Germany",
    callingCode: "+49",
    currency: "EUR",
    currencyName: "Euro",
  },
  {
    name: "India",
    callingCode: "+91",
    currency: "INR",
    currencyName: "Indian Rupee",
  },
  {
    name: "Italy",
    callingCode: "+39",
    currency: "EUR",
    currencyName: "Euro",
  },
  {
    name: "Japan",
    callingCode: "+81",
    currency: "JPY",
    currencyName: "Yen",
  },
  {
    name: "Kenya",
    callingCode: "+254",
    currency: "KES",
    currencyName: "Kenyan Shilling",
  },
  {
    name: "Kuwait",
    callingCode: "+965",
    currency: "KWD",
    currencyName: "Kuwaiti Dinar",
  },
  {
    name: "Namibia",
    callingCode: "+264",
    currency: "NAD",
    currencyName: "Namibian Dollar",
  },
  {
    name: "Nigeria",
    callingCode: "+234",
    currency: "NGN",
    currencyName: "Naira",
  },
  {
    name: "Pakistan",
    callingCode: "+92",
    currency: "PKR",
    currencyName: "Pakistani Rupee",
  },
  {
    name: "Russia",
    callingCode: "+7",
    currency: "RUB",
    currencyName: "Russian Ruble",
  },
  {
    name: "Saudi Arabia",
    callingCode: "+966",
    currency: "SAR",
    currencyName: "Saudi Riyal",
  },
  {
    name: "South Africa",
    callingCode: "+27",
    currency: "ZAR",
    currencyName: "Rand",
  },
  {
    name: "Spain",
    callingCode: "+34",
    currency: "EUR",
    currencyName: "Euro",
  },
  {
    name: "Sweden",
    callingCode: "+46",
    currency: "SEK",
    currencyName: "Swedish Krona",
  },
  {
    name: "Switzerland",
    callingCode: "+41",
    currency: "CHF",
    currencyName: "Swiss Franc",
  },
  {
    name: "United Kingdom",
    callingCode: "+44",
    currency: "GBP",
    currencyName: "Pound Sterling",
  },
  {
    name: "United States",
    callingCode: "+1",
    currency: "USD",
    currencyName: "US Dollar",
  },
  {
    name: "Zambia",
    callingCode: "+260",
    currency: "ZMW",
    currencyName: "Zambian Kwacha",
  },
  {
    name: "Zimbabwe",
    callingCode: "+263",
    currency: "ZiG",
    currencyName: "Zimbabwe Gold",
  },
];
